<template>
    <div>
        <v-row>
            <v-col>
                <h4 class="text-h4">Sales Quotations</h4>
                <p class="text-subtitle-1">List of Sales Quotations.</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3" v-if="hasPermission(perm.quotation.create)">
                <v-btn color="primary" block @click="handleNewQuotation" >
                    <v-icon left >mdi-plus</v-icon>
                    new Quotation
                </v-btn>
            </v-col>
                        <v-col cols="12" md="3">
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            block
                            depressed
                            v-on="on"
                            v-bind="attrs"
                        >
                            <v-icon left>mdi-magnify</v-icon>
                            search
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>Search</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        outlined
                                        dense
                                        hide-details="auto"
                                        label="Name"
                                        v-model="form.name"
                                    >

                                    </v-text-field
                                    >
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        outlined
                                        dense
                                        hide-details="auto"
                                        label="Code"
                                        v-model="form.code"
                                    >

                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        outlined
                                        dense
                                        hide-details="auto"
                                        label="Phone"
                                        v-model="form.phone"
                                    >

                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <UserSearch
                                        dense
                                        label="Created By"
                                        outlined
                                        hide-details
                                        item-value="id"
                                        item-text="name"
                                        append-icon="mdi-account"
                                        v-model="form.created_by_id"
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <DatePicker
                                    outlined
                                    dense
                                    hide-details
                                    label="Date From"
                                    v-model="form.date_from"
                                    clearable
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col align-self="center">
                                    <DatePicker
                                    outlined
                                    dense
                                    hide-details
                                    label="Date to"
                                    v-model="form.date_to"
                                    clearable
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-row no-gutters>
                                <v-col >
                                    <v-btn block color="primary" @click="handleSearchForm">
                                        search
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    :headers="headers.quotation"
                    :items="quotations"
                    :options.sync="options"
                    :server-items-length="quotationLength"
                    :page.sync="page"
                    :footer-props="{ 'items-per-page-options': [10,25,50] }"
                    @dblclick:row="handleRowDoubleClick"
                    dense
                    :loading="loading.data">
                    <template v-slot:[`item.code`]="{item}">
                        <v-btn icon @click="navgateToDisplay(item)" @mouseover="handleMouseOver"  @mouseout="handleMouseLefe" v-if="hasPermission(perm.quotation.read)">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        {{item.code}}
                    </template>
                    <template v-slot:[`item.total`]="{ item }">
                        {{ formatMoney(item.total, "SDG ", 2) }}
                    </template>
                    <template v-slot:[`item.created_at`]="{item}">
                        {{ moment(item.created_at).format('YYYY-MM-DD')}}
                    </template>
                    
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import permissions from './../../data/permissions';
import UserSearch from './../../components/searchComponents/UserSearch';
import DatePicker from './../../components/common/DatePicker.vue'
import {formatMoney} from 'accounting';
import moment from 'moment';
import { mapActions, mapState } from 'vuex'
import authorize from '../../utils/authorize';
export default {
    name: "QuotatonListView",
    components: {
        DatePicker,
        UserSearch
    },
    data() {
        return {
            loading: {
                data: false
            },
            headers: {
                quotation: [
                    { text: this.$t('code'), value: 'code' },
                    { text: this.$t('date'), value: 'date' },
                    { text: this.$t('customer'), sortable: false, value: "customer" },
                    { text: this.$t('validity_date'), value: "validity_date" },
                    { text: this.$t('total'), sortable: false, value: "total" },
                    { text: this.$t('created_at'), value: 'created_at'},
                    { text: this.$t('created_by'), value: "created_by" }
                ]
            },
            options: {},
            quotationLength: 0,
            search: null,
            form: {
                name: null,
                code: null,
                date_from: null,
                date_to: null,
                created_by_id: null,
                phone: null
            },
            page: 1,
            perm: permissions
        }
    },
    computed: {
        ...mapState("sales/quotation", ["quotations"]),
    },
    watch: {
        options: {
            handler () {
                this.createDataFetch();
            },
            deep: true
        }
    },
    methods: {
        moment,
        formatMoney,
        ...mapActions("sales/quotation", ["fetchQuotations"]),
        hasPermission(code) {
            return authorize(code)
        },
        handleNewQuotation() {
            this.$router.push({ name: "QuotationCreate"})
        },
        async createDataFetch() {
            this.loading.data = true;
            let result = await this.fetchQuotations(this.options);
            this.quotationLength = result.data.total;
            this.loading.data = false;
        },
        navgateToDisplay(item) {
            this.$router.push({name: "QuotationDisplay",  params: { id: item.id} })

        },
        handleMouseOver(e) {
            e.target.style.transform = "scale(1.5)"
        },
        handleMouseLefe(e) {
            e.target.style.transform = "scale(1)"
        },
        handleSearchForm() {
            this.page = 1;
            this.options = { ...this.options, ...this.form}
        },
        handleRowDoubleClick(e, { item }) {
            this.navgateToDisplay(item)
        }
    },
    mounted() {
        this.createDataFetch()
    }
}
</script>

<style>

</style>